import React, { Component, Fragment } from 'react'
import { Container,Col, Row } from 'react-bootstrap'

import pic1 from '../../asset/image/1.jpg';
import pic2 from '../../asset/image/2.jpg';
import pic3 from '../../asset/image/3.jpg';
import pic4 from '../../asset/image/4.jpg';
import pic5 from '../../asset/image/5.jpg';
import pic6 from '../../asset/image/6.jpg';
import pic7 from '../../asset/image/7.jpg';
import pic8 from '../../asset/image/8.jpg';
import pic9 from '../../asset/image/9.jpg';
import pic10 from '../../asset/image/10.jpg';
import pic11 from '../../asset/image/11.jpg';
import pic12 from '../../asset/image/12.jpg';
import pic13 from '../../asset/image/13.jpg';
import pic14 from '../../asset/image/14.jpg';
import pic15 from '../../asset/image/15.jpg';
import pic16 from '../../asset/image/16.jpg';
import pic17 from '../../asset/image/17.jpg';


export class Gallery extends Component {
  render() {
    return (
     <Fragment>
        <Container className='text-center courseBackpic'>
          
   <Row>   
                <Col lg={12} md={12} sm={12} className='p-2'>
                <Row>
                    <Col lg={3} md={6} sm={12}>
                    <img className="galleryImage"src={pic1}></img>
                    </Col>

                    <Col lg={3} md={6} sm={12}>
                   <img className="galleryImage"src={pic2}></img>
                    </Col>

                    <Col lg={3} md={6} sm={12} className='p-2'>
                    <img className="galleryImage"src={pic3}></img>
                    
                    </Col>

                    <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic4}></img>  
                    </Col>
                     <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic5}></img>  
                    </Col>
                     <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic6}></img>  
                    </Col>
                  
                 
                  
                   <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic8}></img>  
                    </Col>
                  
                   <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic9}></img>  
                    </Col>
                  
                   <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic10}></img>  
                    </Col>
                  
                   <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic11}></img>  
                    </Col>
                  
                   <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic13}></img>  
                    </Col>
                  
                   <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic14}></img>  
                    </Col>
                  
                   <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic15}></img>  
                    </Col>
                     <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic16}></img>  
                    </Col>
                  
                   <Col lg={3} md={6} sm={12} className='p-2' >
                     <img className="galleryImage"src={pic17}></img>  
                    </Col>
                  
                  
                  

                </Row>
                </Col>
                </Row>



        </Container>
     </Fragment>
    )
  }
}

export default Gallery
